export default "__VITE_ASSET__SgZrYcoR__"